export const navigation = [
    {
        text: 'Système',
        path: "",
        icon: "event",
        items: [
            {
                text: "Configuration",
                path: "",
                icon: "group",
                items: [
                    {
                        text: "Schémas",
                        path: "gestion-schemas",
                        icon: "group"
                    },
                    {
                        text: "Application",
                        path: "configuration-application",
                        icon: "group"
                    },
                    {
                        text: "Définitions",
                        path: "",
                        icon: "group",
                        items: [
                            {
                                text: "Colonnes de plans par défaut",
                                path: "definition-colonnes-plans",
                                icon: "group"
                            },
                            {
                                text: "Congés fériés",
                                path: "definition-conges-feries",
                                icon: "group"
                            },
                        ]
                    },
                    {
                        text: "Terme & condition",
                        path: "terme-condition",
                        icon: "group"
                    },
                    {
                        text: "Langues",
                        path: "configuration-langues",
                        icon: "group"
                    },
                    {
                        text: "Pays",
                        path: "configuration-pays",
                        icon: "group"
                    },
                    {
                        text: "Provinces",
                        path: "configuration-provinces",
                        icon: "group"
                    },
                    {
                        text: "Tranches d'âges",
                        path: "configuration-tranches-ages",
                        icon: "group"
                    },
                    {
                        text: "Catégories de clients",
                        path: "configuration-categories-clients",
                        icon: "group"
                    },
                    {
                        text: "Titres de clients",
                        path: "configuration-clients-titres",
                        icon: "group"
                    },
                    {
                        text: "Réservations",
                        path: "configuration-reservation",
                        icon: "group"
                    },
                    {
                        text: "Enregistrements",
                        path: "configuration-enregistrements",
                        icon: "group"
                    },
                    {
                        text: "Facturation",
                        path: "configuration-facturation",
                        icon: "group"
                    },
                    {
                        text: "Comptabilité",
                        path: "configuration-comptabilite",
                        icon: "group"
                    },
                    {
                        text: "Imprimantes",
                        path: "configuration-imprimantes",
                        icon: "group"
                    },
                    {
                        text: "Serveur courriel",
                        path: "configuration-serveur-courriel",
                        icon: "group"
                    },
                    {
                        text: "Paramètres Web",
                        path: "configuration-parametres-web",
                        icon: "group"
                    },
                    {
                        text: "Matériel",
                        path: "configuration-materiel",
                        icon: "group"
                    }
                ]
            },
            {
                text: "Calculateur de tarifs web",
                path: "gestion-calculateur-tarifs-web",
                icon: "group"
            },
            {
                text: "Entreprises",
                path: "gestion-entreprises",
                icon: "group"
            },
            {
                text: "Permissions",
                path: "gestion-permissions",
                icon: "group"
            },
            {
                text: "Usagers",
                path: "gestion-usagers",
                icon: "group"
            }
        ]
    },
    {
        text: 'Client',
        path: "gestion-client",
        icon: "event",

    },
    {
        text: 'Réservation',
        path: "",
        icon: "event",
        items: [
            {
                text: 'Calendrier',
                path: 'calendrier',
                icon: "group"
            },
            {
                text: 'Réservations',
                path: 'gestion-reservation',
                icon: "group"
            },
            {
                text: 'Synchronisation',
                path: 'synchronisation',
                icon: "group"
            },
            {
                text: 'Gestion',
                path: '',
                icon: "group",
                items: [
                    {
                      text: "Catégories d'unités",
                      path: "gestion-categories-unites",
                      icon: "group"
                    },
                    {
                        text: "Catégories de clients",
                        path: "gestion-categories-clients",
                        icon: "group"
                    },
                    {
                        text: "Channel manager",
                        path: "gestion-channel-manager",
                        icon: "group"
                    },
                    /*{
                      text: "Liste des résidents",
                      path: "gestion-liste-residents",
                      icon: "group"
                    },*/
                    /*{
                      text: "Liste des occupants",
                      path: "gestion-liste-occupants",
                      icon: "group"
                    },*/
                    {
                        text: "Liste des arrivées",
                        path: "gestion-liste-arrivee",
                        icon: "group"
                    },
                    /*{
                      text: "Dépôts",
                      path: "gestion-depots",
                      icon: "group"
                    },*/
                    // {
                    //   text: "Correction de villes",
                    //   path: "gestion-correction-villes",
                    //   icon: "group"
                    // },
                    {
                        text: "Évènements",
                        path: "gestion-evenements",
                        icon: "group"
                    },
                   /* {
                        text: "Fusion de clients",
                        path: "gestion-fusion-clients",
                        icon: "group"
                    },*/
                    {
                        text: "Groupes de types d'unités",
                        path: "gestion-groupes-types-unites",
                        icon: "group"
                    },
                    {
                      text: 'Historique des entrées',
                      path: 'gestion-historique-entrees',
                      icon: "group"
                    },
                    {
                        text: "Messages",
                        path: "gestion-messages",
                        icon: "group"
                    },
                    {
                        text: "Plans",
                        path: "gestion-plans",
                        icon: "group"
                    },
                    {
                        text: "Promotions",
                        path: "gestion-promotions",
                        icon: "group"
                    },
                    {
                        text: "Publipostage",
                        path: "gestion-publipostage",
                        icon: "group"
                    },
                    {
                        text: "Types d'équipements",
                        path: "gestion-types-equipements",
                        icon: "group"
                    },
                    {
                        text: "Types d'unités",
                        path: "gestion-types-unites",
                        icon: "group"
                    },
                    {
                        text: "Types de permis",
                        path: "gestion-types-permis",
                        icon: "group"
                    },
                    {
                        text: "Types de services",
                        path: "gestion-types-services",
                        icon: "group"
                    },
                    {
                        text: "Types de transports",
                        path: "gestion-types-transports",
                        icon: "group"
                    },
                    {
                        text: "Unités",
                        path: "gestion-unites",
                        icon: "group"
                    },
                    /* {
                       text: "Soumissions web acampa",
                       path: "",
                       icon: "group"
                     },*/
                ]
            },
            {
                text: 'Rapports',
                icon: "group",
                items: [
                    {
                        text: "Dépôt clients",
                        path: "depot-clients?rapport=Depot clients",
                        icon: "group"
                    },
                    {
                        text: "Journal des paiements",
                        path: "journal-paiements?rapport=Journal des paiements",
                        icon: "group"
                    },
                    {
                        text: "Journal des ventes",
                        path: "journal-ventes?rapport=Journal des ventes",
                        icon: "group"
                    },
                    {
                        text: "Liste des clients",
                        path: "liste-clients?rapport=Liste des clients",
                        icon: "group"
                    },
                    {
                        text: "Liste des items vendus",
                        path: "liste-items-vendus?rapport=Liste des items vendus",
                        icon: "group"
                    },
                    {
                        text: "Liste des réservations",
                        path: "liste-reservations?rapport=Liste des réservations",
                        icon: "group"
                    },
                    {
                        text: "Liste des arrivées et des départs",
                        path: "liste-arrivee-depart?rapport=Liste des arrivées et des départs",
                        icon: "group"
                    },
                    {
                        text: "Rapport de caisse",
                        path: "rapport-de-caisse?rapport=Rapport de Caisse",
                        icon: "group"
                    },
                    {
                        text: "Taux d'occupation",
                        path: "taux-occupation?rapport=Taux d'occupation",
                        icon: "group"
                    },
                    {
                        text: "Liste des repas par unité",
                        path: "liste-repas-unite?rapport=Liste des repas par unité",
                        icon: "group"
                    },
                    {
                        text: "Ventes folio détaillé",
                        path: "ventes-folio-detaille?rapport=Ventes folio détaillé",
                        icon: "group"
                    },
                    {
                        text: "Rapport ventes détaillé",
                        path: "rapport-ventes-detaille?rapport=Rapport des ventes détaillé",
                        icon: "group"
                    },
                    {
                        text: "Valeur de l'inventaire",
                        path: "rapport-valeur-inventaire?rapport=Valeur de l'inventaire",
                        icon: "group"
                    },
                    {
                        text: "Planification des repas",
                        path: "rapport-planification-repas?rapport=Planification des repas",
                        icon: "group"
                    },
                    {
                        text: "Liste des ménages",
                        path: "liste-menages?rapport=Liste des ménages",
                        icon: "group"
                    },
                    {
                        text: "Nombres de nuitées annuel par types d'unités",
                        path: "nombres-nuitees-annuel-type-unite?rapport=Nombres de nuitées annuel par types d'unités",
                        icon: "group"
                    },
                    {
                        text: "Montant à recevoir",
                        path: "montant-recevoir?rapport=Montant à recevoir",
                        icon: "group"
                    },
                ]
                /* items: [
                   {
                     text: "Achalandage des postes d'enregistrement",
                     path: "rapports-reservation?rapport=Achalandage des postes d'enregistrement",
                     icon: "group"
                   },
                   {
                     text: 'Achalandage mensuel des activités par lieux de séjours',
                     path: "rapports-reservation?rapport=Achalandage mensuel des activités par lieux de séjours",
                     icon: "group"
                   },
                   {
                     text: 'Achalandage par activité et par provenance',
                     path: "rapports-reservation?rapport=Achalandage par activité et par provenance",
                     icon: "group"
                   },
                   {
                     text: 'Achalandage par catégorie de client',
                     path: "rapports-reservation?rapport=Achalandage par catégorie de client",
                     icon: "group"
                   },
                   {
                     text: "Achalandage par période",
                     path: "rapports-reservation?rapport=Achalandage par période",
                     icon: "group"
                   },
                   {
                     text: "Achalandage par types et lieux de séjour",
                     path: "rapports-reservation?rapport=Achalandage par types et lieux de séjour",
                     icon: "group"
                   },
                   {
                     text: "Activités des réservations",
                     path: "rapports-reservation?rapport=Activités des réservations",
                     icon: "group"
                   },
                   {
                     text: "Activités effectués par période",
                     path: "rapports-reservation?rapport=Activités effectués par période",
                     icon: "group"
                   },
                   {
                     text: "Analyse des statistiques de pêche",
                     path: "rapports-reservation?rapport=Analyse des statistiques de pêche",
                     icon: "group"
                   },
                   {
                     text: "Catalogue des produits",
                     path: "rapports-reservation?rapport=Catalogue des produits",
                     icon: "group"
                   },
                   {
                     text: "Charte comptable",
                     path: "rapports-reservation?rapport=Charte comptable",
                     icon: "group"
                   },
                   {
                     text: "Dépôts clients",
                     path: "rapports-reservation?rapport=Dépôts clients",
                     icon: "group"
                   },
                   {
                     text: "Dépôts en retard",
                     path: "rapports-reservation?rapport=Dépôts en retard",
                     icon: "group"
                   },
                   {
                     text: "État de compte",
                     path: "rapports-reservation?rapport=État de compte",
                     icon: "group"
                   },
                   {
                     text: "Feuillets d'enregistrements non remis",
                     path: "rapports-reservation?rapport=Feuillets d'enregistrements non remis",
                     icon: "group"
                   },
                   {
                     text: "Historique d'un client",
                     path: "rapports-reservation?rapport=Historique d'un client",
                     icon: "group"
                   },
                   {
                     text: "Impression de billets",
                     path: "rapports-reservation?rapport=Impression de billets",
                     icon: "group"
                   },
                   {
                     text: "Impression de dépôt",
                     path: "rapports-reservation?rapport=Impression de dépôt",
                     icon: "group"
                   },
                   {
                     text: "Journal des ventes",
                     path: "rapports-reservation?rapport=Journal des ventes",
                     icon: "group"
                   },
                   {
                     text: "Liste critériée des clients",
                     path: "rapports-reservation?rapport=Liste critériée des clients",
                     icon: "group"
                   },
                   {
                     text: "Liste des achats d'unités réservés",
                     path: "rapports-reservation?rapport=Liste des achats d'unités réservés",
                     icon: "group"
                   },
                   {
                     text: "Liste des arrivées",
                     path: "rapports-reservation?rapport=Liste des arrivées",
                     icon: "group"
                   },
                   {
                     text: "Liste des caches",
                     path: "rapports-reservation?rapport=Liste des caches",
                     icon: "group"
                   },
                   {
                     text: "Liste des chasseurs",
                     path: "rapports-reservation?rapport=Liste des chasseurs",
                     icon: "group"
                   },
                   {
                     text: "Liste des clients",
                     path: "rapports-reservation?rapport=Liste des clients",
                     icon: "group"
                   },
                   {
                     text: "Liste des départs",
                     path: "rapports-reservation?rapport=Liste des départs",
                     icon: "group"
                   },
                   {
                     text: "Liste des groupes de chasseurs",
                     path: "rapports-reservation?rapport=Liste des groupes de chasseurs",
                     icon: "group"
                   },
                   {
                     text: "Liste des items vendus",
                     path: "rapports-reservation?rapport=Liste des items vendus",
                     icon: "group"
                   },
                   {
                     text: "Liste des membres",
                     path: "rapports-reservation?rapport=Liste des membres",
                     icon: "group"
                   },
                   {
                     text: "Liste des ménages",
                     path: "rapports-reservation?rapport=Liste des ménages",
                     icon: "group"
                   },
                   {
                     text: "Liste des passages FQCQ",
                     path: "rapports-reservation?rapport=Liste des passages FQCQ",
                     icon: "group"
                   },
                   {
                     text: "Liste des permis",
                     path: "rapports-reservation?rapport=Liste des permis",
                     icon: "group"
                   },
                   {
                     text: "Liste des plans",
                     path: "rapports-reservation?rapport=Liste des plans",
                     icon: "group"
                   },

                   {
                     text: "Liste des points d'eau",
                     path: "rapports-reservation?rapport=Liste des points d'eau",
                     icon: "group"
                   },
                   {
                     text: "Liste des repas par unité",
                     path: "rapports-reservation?rapport=Liste des repas par unité",
                     icon: "group"
                   },
                   {
                     text: "Liste des réservations",
                     path: "rapports-reservation?rapport=Liste des réservations",
                     icon: "group"
                   },
                   {
                     text: "Liste des réservations avec balance due",
                     path: "rapports-reservation?rapport=Liste des réservations avec balance due",
                     icon: "group"
                   },
                   {
                     text: "Liste des résidents",
                     path: "rapports-reservation?rapport=Liste des résidents",
                     icon: "group"
                   },
                   {
                     text: "Liste des roulottes",
                     path: "rapports-reservation?rapport=Liste des roulottes",
                     icon: "group"
                   },
                   {
                     text: "Liste des types de transport",
                     path: "rapports-reservation?rapport=Liste des types de transport",
                     icon: "group"
                   },
                   {
                     text: "Liste des unités",
                     path: "rapports-reservation?rapport=Liste des unités",
                     icon: "group"
                   },
                   {
                     text: "Liste des usagers",
                     path: "rapports-reservation?rapport=Liste des usagers",
                     icon: "group"
                   },
                   {
                     text: "Montants à recevoir",
                     path: "rapports-reservation?rapport=Montants à recevoir",
                     icon: "group"
                   },
                   {
                     text: "Nombres de nuitées annuel par types d'unités",
                     path: "rapports-reservation?rapport=Nombres de nuitées annuel par types d'unités",
                     icon: "group"
                   },
                   {
                     text: "Planification des repas",
                     path: "rapports-reservation?rapport=Planification des repas",
                     icon: "group"
                   },
                   {
                     text: "Points d'eau à fermer",
                     path: "rapports-reservation?rapport=Points d'eau à fermer",
                     icon: "group"
                   },
                   {
                     text: "Présences sur le territoire",
                     path: "rapports-reservation?rapport=Présences sur le territoire",
                     icon: "group"
                   },
                   {
                     text: "Provenance des clients",
                     path: "rapports-reservation?rapport=Provenance des clients",
                     icon: "group"
                   },
                   {
                     text: "Quotas des points d'eau",
                     path: "rapports-reservation?rapport=Quotas des points d'eau",
                     icon: "group"
                   },
                   {
                     text: "Rapport d'activités annuel pourvoirie",
                     path: "rapports-reservation?rapport=Rapport d'activités annuel pourvoirie",
                     icon: "group"
                   },
                   {
                     text: "Rapport de caisse",
                     path: "rapports-reservation?rapport=Rapport de caisse",
                     icon: "group"
                   },
                   {
                     text: "Rapport des ventes detaillé",
                     path: "rapports-reservation?rapport=Rapport des ventes detaillé",
                     icon: "group"
                   },
                   {
                     text: "Rapport d'un client",
                     path: "rapports-reservation?rapport=Rapport d'un client",
                     icon: "group"
                   },
                   {
                     text: "Résultats des tirages",
                     path: "rapports-reservation?rapport=Résultats des tirages",
                     icon: "group"
                   },
                   {
                     text: "Statistiques de captures(chasse)",
                     path: "rapports-reservation?rapport=Statistiques de captures(chasse)",
                     icon: "group"
                   },
                   {
                     text: "Statistiques de fréquentation",
                     path: "rapports-reservation?rapport=Statistiques de fréquentation",
                     icon: "group"
                   },
                   {
                     text: "Statistiques de prises(pêche)",
                     path: "rapports-reservation?rapport=Statistiques de prises(pêche)",
                     icon: "group"
                   },
                   {
                     text: "Statistiques de prises de pêche par type de séjours",
                     path: "rapports-reservation?rapport=Statistiques de prises de pêche par type de séjours",
                     icon: "group"
                   },
                   {
                     text: "Statistiques de prises de saumons",
                     path: "rapports-reservation?rapport=Statistiques de prises de saumons",
                     icon: "group"
                   },
                   {
                     text: "Statistiques de prises de saumons par emplacement",
                     path: "rapports-reservation?rapport=Statistiques de prises de saumons par emplacement",
                     icon: "group"
                   },
                   {
                     text: "Statistiques de prises sommaire(pêche)",
                     path: "rapports-reservation?rapport=Statistiques de prises sommaire(pêche)",
                     icon: "group"
                   },
                   {
                     text: "Statistiques des fiches d'enregistrement",
                     path: "rapports-reservation?rapport=Statistiques des fiches d'enregistrement",
                     icon: "group"
                   },
                   {
                     text: "Statistiques des perches par point d'eau",
                     path: "rapports-reservation?rapport=Statistiques des perches par point d'eau",
                     icon: "group"
                   },
                   {
                     text: "Statistiques d'hébergement annuel",
                     path: "rapports-reservation?rapport=Statistiques d'hébergement annuel",
                     icon: "group"
                   },
                   {
                     text: "Statistiques publicitaires",
                     path: "rapports-reservation?rapport=Statistiques publicitaires",
                     icon: "group"
                   },
                   {
                     text: "Tableau des réservations",
                     path: "rapports-reservation?rapport=Tableau des réservations",
                     icon: "group"
                   },
                   {
                     text: "Taux d'occupation",
                     path: "rapports-reservation?rapport=Taux d'occupation",
                     icon: "group"
                   },
                   {
                     text: "Valeur de l'inventaire",
                     path: "rapports-reservation?rapport=Valeur de l'inventaire",
                     icon: "group"
                   },
                   {
                     text: "Ventes par folio détaillé",
                     path: "rapports-reservation?rapport=Ventes par folio détaillé",
                     icon: "group"
                   }
                 ]*/
            },]
    },
    {
        text: 'Facturation',
        path: "",
        icon: "event",
        items: [
            {
                text: 'Factures',
                path: 'gestion-facturation',
                icon: "group"
            },
            {
                text: 'Gestion',
                path: '',
                icon: "group",
                items: [
                    {
                        text: "Catalogue des produits",
                        path: "gestion-catalogue-produits",
                        icon: "group"
                    },
                    {
                        text: "Codes de barrière",
                        path: "gestion-codes-barriere",
                        icon: "group"
                    },
                    {
                        text: "Folios",
                        path: "gestion-folios",
                        icon: "group"
                    },
                    {
                        text: "Historique des rapports TPV",
                        path: "",
                        icon: "group"
                    },
                    {
                        text: "Institutions financières",
                        path: "gestion-institutions-financieres",
                        icon: "group"
                    },
                    {
                        text: "Modification d'inventaire",
                        path: "gestion-modification-inventaire",
                        icon: "group"
                    },
                    {
                        text: "Montants dûs",
                        path: "gestion-montants-dus",
                        icon: "group"
                    },
                    {
                        text: "Point de vente",
                        path: "gestion-points-vente",
                        icon: "group"
                    },
                    {
                        text: "Taxes",
                        path: "gestion-taxes",
                        icon: "group"
                    },
                    {
                        text: "Tirages",
                        path: "gestion-tirages",
                        icon: "group"
                    },
                    {
                        text: "Transfert vers Acomba",
                        path: "gestion-transfert-acomba",
                        icon: "group"
                    },
                    {
                        text: "Types de paiements",
                        path: "gestion-types-paiements",
                        icon: "group"
                    },
                    /*{
                      text: "Rapports TPV",
                      path: "rapports-tpv",
                      icon: "group"
                    },*/
                    {
                        text: "Recettes",
                        path: "gestion-recettes",
                        icon: "group"
                    }, {
                        text: "Facturations de compteurs",
                        path: "gestion-facturation-compteurs",
                        icon: "group"
                    },
                ]
            }]
    },
    {
        text: 'Enregistrement',
        path: "",
        icon: "event",
        items: [{
            text: 'Enregistrements',
            path: 'gestion-enregistrements',
            icon: "group"
        },
            {
                text: 'Gestion',
                path: '',
                icon: "group",
                items: [
                    {
                        text: "Activités",
                        path: "gestion-activites",
                        icon: "group"
                    },
                    {
                        text: "Caches",
                        path: "gestion-caches",
                        icon: "group"
                    },
                    {
                        text: "Commandites",
                        path: "gestion-commandites",
                        icon: "group"
                    },
                    {
                        text: "Espèces",
                        path: "gestion-especes",
                        icon: "group"
                    },
                    {
                        text: "Gibiers",
                        path: "gestion-gibiers",
                        icon: "group"
                    },
                    {
                        text: "Groupes de chasseurs",
                        path: "gestion-groupes-chasseurs",
                        icon: "group"
                    },
                    {
                        text: "Lieux de séjour",
                        path: "gestion-lieux-sejour",
                        icon: "group"
                    },
                    {
                        text: "Points d'eau",
                        path: "gestion-points-eau",
                        icon: "group"
                    },
                    {
                        text: "Poste d'enregistrement",
                        path: "gestion-poste-enregistrement",
                        icon: "group"
                    },
                    {
                        text: "Secteurs",
                        path: "gestion-secteurs",
                        icon: "group"
                    },
                    {
                        text: "Types de séjours",
                        path: "gestion-types-sejours",
                        icon: "group"
                    },
                    {
                        text: "Roulottes",
                        path: "gestion-roulottes",
                        icon: "group"
                    }
                ]
            },
            {
                text: 'Rapports',
                path: '',
                icon: 'group',
                items: [
                    {
                        text: "Achalandage des postes d'enregistrements",
                        path: 'achalandage-postes-enregistrements',
                        icon: 'group'
                    },
                    {
                        text: "Achalandage mensuel des activités par lieux de séjours",
                        path: 'achalandage-mensuel-activites-lieux-sejours',
                        icon: 'group'
                    },
                    {
                        text: "Achalandage par période",
                        path: 'achalandage-periode',
                        icon: 'group'
                    },
                    {
                        text: "Achalandage par types et lieux de séjour",
                        path: 'achalandage-types-lieux-sejour',
                        icon: 'group'
                    },
                    {
                        text: "Activités effectués par période",
                        path: 'achalandage-effectue-periode',
                        icon: 'group'
                    },
                    {
                        text: "Analyse des statiques de pêche",
                        path: 'analyse-statiques-peche',
                        icon: 'group'
                    },
                    {
                        text: "Feuillets d'enregistrements nom remis",
                        path: 'feuillets-enregistrements-nom-remis',
                        icon: 'group'
                    },
                    {
                        text: "Liste des caches",
                        path: 'liste-caches',
                        icon: 'group'
                    },
                    {
                        text: "Liste des chasseurs",
                        path: 'liste-chasseurs',
                        icon: 'group'
                    },
                    {
                        text: "Liste des groupes de chasseurs",
                        path: 'liste-groupe-chasseurs',
                        icon: 'group'
                    },
                    {
                        text: "Liste des membres",
                        path: 'liste-membre',
                        icon: 'group'
                    },
                    {
                        text: "Liste des passages FQCQ",
                        path: 'liste-passages-fqcq',
                        icon: 'group'
                    },
                    {
                        text: "Liste des points d'eau",
                        path: 'liste-points-eau',
                        icon: 'group'
                    },
                    {
                        text: "Liste des roulottes",
                        path: 'liste-roulottes',
                        icon: 'group'
                    },
                    {
                        text: "Points d'eau a fermer",
                        path: 'points-eau-a-fermer',
                        icon: 'group'
                    },
                    {
                        text: "Présences sur le territoire",
                        path: 'presences-sur-territoire',
                        icon: 'group'
                    },
                    {
                        text: "Quotas des points d'eau",
                        path: 'quotas-points-eau',
                        icon: 'group'
                    },
                    {
                        text: "Statistiques de captures (chasse)",
                        path: 'statistiques-captures',
                        icon: 'group'
                    },
                    {
                        text: "Statistiques de prises (pêche)",
                        path: 'statistiques-prises',
                        icon: 'group'
                    },
                    {
                        text: "Statistiques de prises de pêche par type de séjours",
                        path: 'statistiques-prises-pêche-type-sejours',
                        icon: 'group'
                    },
                    {
                        text: "Statistiques des fichiers d'enregistrement",
                        path: 'statistiques-fichiers-enregistrement',
                        icon: 'group'
                    }
                ]
            }
        ]
    },
    {
        text: 'Grand livre',
        path: "",
        icon: "event",
        items: [
            {
                text: "Journal",
                path: "grand-livre-journal",
                icon: "group"
            },
            {
                text: "Fermetures de modules",
                path: "grand-livre-fermetures-modules",
                icon: "group"
            },
            {
                text: "Groupe état financier",
                path: "grand-livre-etat-financier",
                icon: "group"
            },
            {
                text: "Générer les écritures d'ouverture",
                path: "grand-livre-generer-ecritures-ouverture",
                icon: "group"
            },
            {
                text: "Contrats",
                path: "grand-livre-gestion-contrats",
                icon: "group"
            },
            {
                text: "Folios",
                path: "grand-livre-folios",
                icon: "group"
            },
            {
                text: "Promotion Condition",
                path: "gestion-promotion-condition",
                icon: "group"
            }
        ]
    }
    // ,{
    //    text: 'Paie',
    //    path: "",
    //    icon: "event",
    //    items: [
    //      {
    //        text: "CCQ",
    //        path: "",
    //        icon: "group",
    //        items: [
    //          {
    //            text: "Compétences",
    //            path: "competences-metier",
    //            icon: "group"
    //          },
    //          {
    //            text: "Métiers",
    //            path: "paie-metiers",
    //            icon: "group"
    //          },
    //          {
    //            text: "Secteurs de métier",
    //            path: "secteurs-metier",
    //            icon: "group"
    //          },
    //          {
    //            text: "Taux CCQ",
    //            path: "taux-ccq",
    //            icon: "group"
    //          }
    //        ]
    //      }
    //    ]
    //  },
    /*  {
        text: 'Fournisseur',
        path: "",
        icon: "event",
        items: []
      },*/
    /*{
      text: 'Grand livre',
      path: "",
      icon: "event",
      items: []
    }*/
    // Pages qu'il ne fallait pas faire
    //{
    //  text: "Évènement",
    //  path: "gestion-evenement",
    //  icon: "group"
    //},
    //{
    //  text: "Contribution santé",
    //  path: "contribution-sante",
    //  icon: "group"
    //},
    //{
    //  text: "Gestion de contrats",
    //  path: "gestion-contrats",
    //  icon: "group"
    //},
    //{
    //  text: "CSST",
    //  path: "gestion-csst",
    //  icon: "group"
    //},
    //{
    //  text: "Journal",
    //  path: "gestion-journal",
    //  icon: "group"
    //},
    //{
    //  text: "Relevés 1",
    //  path: "gestion-releves1",
    //  icon: "group"
    //},
    //{
    //  text: "Gestion des syndicats",
    //  path: "gestion-syndicats",
    //  icon: "group"
    //},
    //{
    //  text: "Groupes d'états financier",
    //  path: "groupes-etat-financier",
    //  icon: "group"
    //},
    //{
    //  text: "Taux d'imposition",
    //  path: "taux-imposition",
    //  icon: "group"
    //},
    //{
    //  text: "Taux d'imposition fédéral",
    //  path: "taux-imposition-federal",
    //  icon: "group"
    //},
    //{
    //  text: "Taux d'imposition provincial",
    //  path: "taux-imposition-provincial",
    //  icon: "group"
    //},
    //{
    //  text: "Types d'assurances emploi",
    //  path: "types-assurances-emploi",
    //  icon: "group"
    //},
    //{
    //  text: "Types de travails",
    //  path: "types-travails",
    //  icon: "group"
    //},
    //{
    //  text: "Gestion d'achats",
    //  path: "gestion-achats",
    //  icon: "group"
    //},
    //{
    //  text: "Gestion des commandes",
    //  path: "gestion-commandes",
    //  icon: "group"
    //},
    //{
    //  text: "Déboursés",
    //  path: "debourses",
    //  icon: "group"
    //},
    //{
    //  text: "Gestion des employés",
    //  path: "gestion-employes",
    //  icon: "group"
    //},
    //{
    //  text: "Gestion des fournisseurs",
    //  path: "gestion-fournisseurs",
    //  icon: "group"
    //},
    //{
    //  text: "paie",
    //  path: "gestion-paie",
    //  icon: "group"
    //},
    //{
    //  text: "Raisons d'absence",
    //  path: "raisons-absence",
    //  icon: "group"
    //},
    //{
    //  text: "Rapports fournisseurs",
    //  path: "rapports-fournisseurs",
    //  icon: "group"
    //},
    //{
    //  text: "Rapports paie",
    //  path: "rapports-paie",
    //  icon: "group"
    //},
    //{
    //  text: "Revenus et déductions",
    //  path: "revenus-et-deduction",
    //  icon: "group"
    //},
    //{
    //  text: "Types de paiements déboursés",
    //  path: "types-paiements-debourses",
    //  icon: "group"
    //}
];
